/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4CrossDiagIcon32Regular = forwardRef('ArrowDim4CrossDiagIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M19.5 4a1 1 0 0 1 1-1H26a3 3 0 0 1 3 3v5.5a1 1 0 1 1-2 0V6.414L17.414 16 27 25.586V20.5a1 1 0 0 1 2 0V26a3 3 0 0 1-3 3h-5.5a1 1 0 1 1 0-2h5.086L16 17.414 6.414 27H11.5a1 1 0 0 1 0 2H6a3 3 0 0 1-3-3v-5.5a1 1 0 1 1 2 0v5.086L14.586 16 5 6.414V11.5a1 1 0 1 1-2 0V6a3 3 0 0 1 3-3h5.5a1 1 0 1 1 0 2H6.414L16 14.586 25.586 5H20.5a1 1 0 0 1-1-1Z" })));
});
